import React from 'react';
import HeadingBlock from '$/components/global/heading';
import './index.scss';

const PrivacyPolicy: React.FC = () => {
  return (
    <React.Fragment>
      <HeadingBlock title="Bixby Privacy Policy" />
      <div className="terms_privacy">
        <p>
          Bixby Research and Analytics LLC ("BIXBY") respects the privacy rights of our users and is strongly committed
          to protecting your privacy. This Privacy Policy applies to this Site, any app, information collected and
          provided to BIXBY when you provide information on <a href="www.bixbyresearch.com">www.bixbyresearch.com</a>
          &nbsp; (the "Site") or access the Site.
        </p>
        <section>
          <h2>1. Collection and Use Of Your Personal Information.</h2>
          <p>
            BIXBY collects personal information that you voluntarily provide on this Site, which may include your name,
            address, email address, contact information and password etc. If you do not provide certain personal
            information, not all functionality on the site will be available.
          </p>
          <p>
            Do not provide information about others unless you are authorized to do so and consent to have all
            information used, disclosed, and transferred in accordance with this Privacy Policy. By submitting the
            information about others, you represent and warrant that you are authorized to do so and that you have
            received authorization from the person about whom you are providing the information and that person has
            consented to have all information used, disclosed, and transferred in accordance with this Privacy Policy.
          </p>
          <p>
            We use this information for carefully considered business purposes which also benefit our customers and
            which include some or all of the following: to provide our services and products, to communicate with you,
            to help BIXBY improve our services and products and develop new services and products, to provide support
            for our services and products, and for BIXBY internal quality control purposes. to provide you with offers
            and promotions about services and products of BIXBY or of other parties that may be of interest to you, to
            enhance your experience with this Site, including to save your preference and login information, to analyze
            Site usage and analyze use of the Site, to protect the interests, rights, safety, or property of BIXBY or
            others and to monitor compliance with and enforce the terms of any agreement with BIXBY, and to operate our
            services, products, and systems properly.
          </p>
        </section>
        <section>
          <h2>2. Use Of Cookies And Other Electronic Tools.</h2>
          <p>
            BIXBY may place, view, and/or use "cookies", Web server logs, Web beacons, or other electronic tools to
            collect statistical and other information about your use of this Site and other websites. This information
            may include information about the IP address of your computer, browser type, language, operating system, the
            Web pages visited, the date and the time of a visit, the websites you visited immediately before and after
            visiting this Site, the number of links you click within this Site, the functions you use on this Site, the
            databases you view and the searches you request on this Site, and the data you save on or download from this
            Website.
          </p>
          <p>
            BIXBY and the parties with whom we work may use the information collected for various reasons, either on
            behalf of BIXBY or for the other parties' own purposes, including research, analysis, to better serve
            visitors to this Site, to compile aggregate and anonymous information about usage of this Site and other
            websites, other statistics, etc. However, if you have deleted and disabled cookies, these uses will not be
            possible to the extent they are based on cookie information.
          </p>
          <p>
            To assist us with the uses described in this Privacy Policy, information collected about your use of this
            Site or other websites may be aggregated, analyzed or combined with personal or other information about you
            from other online or offline sources. If you prefer that we not combine non-personal information that has
            been collected, through cookies, about your use of this Site or other websites with personal or other
            information about you, then please delete and disable cookies for each browser, on each computer you use to
            surf the Web.
          </p>
          <p>
            Most browsers are set to accept cookies by default. If you prefer, you can usually set your browser to
            disable cookies, or to alert you when cookies are being sent.
          </p>
        </section>
        <section>
          <h2>3. Disclosure of Your Personal Information.</h2>
          <p>
            BIXBY may share your personal information with our designated service providers, including for the purposes
            set out in this Privacy Policy. BIXBY may share with other third parties information about our Site users,
            such as your use of this Site or other websites, and the services provided on this Site or other websites,
            but only on an unattributed and aggregate basis. BIXBY may also disclose your personal information to
            unaffiliated third parties if we believe in good faith that such disclosure is necessary to: (a) comply with
            any applicable law, rule, or regulation, or in response to a subpoena, court order, or other legal process;
            (b) is necessary in connection with a sale, merger, transfer, exchange or other disposition (whether of
            assets, stock or otherwise) of all or a portion of a business of BIXBY; (c) protect the interests, rights,
            safety, or property of BIXBY or others; (d) monitor compliance with and enforce any terms of service on this
            Site; (e) provide our services and products (including allowing a purchaser of BIXBY or a BIXBY division to
            continue to serve you); (f) perform other activities related to such services and products, including
            billing and collection; (g) provide you with offers or promotions from BIXBY; or (h) operate the systems
            that provide our services and products properly. The collection, further use, and/or disclosure of your
            information by Third-Party Providers or by other third parties is not the responsibility of BIXBY. Rather,
            such collection, use, and/or disclosure is governed by the third parties' privacy policies.
          </p>
        </section>
        <section>
          <h2>4. Accuracy, Security, And Retention Of Your Personal Information.</h2>
          <p>
            Any personal information you provide to BIXBY is kept on secure servers. BIXBY uses security measures
            appropriate to the provision of the relevant product or service, such as reasonable administrative,
            technical, personnel, and physical measures (a) to safeguard personal information against loss, theft,
            unauthorized use, disclosure, or modification; and (b) to ensure the integrity of the personal information.
            To help us protect your privacy, you should maintain the secrecy of the logon ID and password you may have
            set up in connection with your participation in this Site's service. Personal information is retained for as
            long as is necessary for the purpose for which it is collected, including legitimate business reasons,
            and/or legal and regulatory requirements.
          </p>
        </section>
        <section>
          <h2>5. Rights With Respect To Your Personal Information.</h2>
          <p>
            Depending on the jurisdiction, you may have the right to access, correct, delete, or restrict use of certain
            personal information covered by this Privacy Policy. Depending on the jurisdiction, you may also have the
            right to request that we refrain from processing personal information. Please bear in mind that if you
            exercise such rights this may affect our ability to provide our products and services. For inquiries about
            your personal information, please contact us:&nbsp;
            <a href="https://www.bixbyresearch.com/contact-us">https://www.bixbyresearch.com/contact-us</a>. While BIXBY
            will make reasonable efforts to accommodate your request, we also reserve the right to impose certain
            restrictions and requirements on such requests, if allowed or required by applicable laws. Please note that
            it may take some time to process your request, consistent with applicable law.
          </p>
        </section>
        <section>
          <h2>6. Links To Third-Party Websites. </h2>
          <p>
            BIXBY may provide links to third-party websites, including social networking websites. Since we do not
            control third-party sites and are not responsible for any information you may provide while on such sites,
            we encourage you to read the privacy policies on those websites before providing any of your information on
            such sites.
          </p>
        </section>
        <section>
          <h2>7. Questions Regarding This Privacy Policy.</h2>
          <p>
            If you have questions regarding this Privacy Policy, please contact us at&nbsp;
            <a href="mailto:info@bixbyresearch.com">info@bixbyresearch.com</a>. Please include "Privacy" in the Subject
            line of your inquiry.
          </p>
        </section>
        <section>
          <h2>8. Your California Privacy Rights.</h2>
          <p>
            If you are a California resident, California Civil Code Section 1798.83 permits you to request information
            regarding the disclosure of your personal information by Bixby Research and Analytics LLC.
          </p>

          <p>
            To make such a request, please send an email with your first name, last name, mailing address, email address
            and telephone number to <a href="mailto:info@bixbyresearch.com">info@bixbyresearch.com</a>. Please include
            "California Privacy Rights" in the Subject line of your email.
          </p>

          <p>You may also make such a request by writing to us at:</p>
          <div>
            <div>Bixby Research and Analytics</div>
            <div>One North Wacker Drive, 23rd Floor</div>
            <div>Chicago, IL 60606</div>
          </div>
          <p>
            Also see <a href="https://www.bixbyresearch.com/contact-us">https://www.bixbyresearch.com/contact-us</a>.
          </p>
        </section>
        <section>
          <h2>9. Modifications To This Privacy Policy</h2>
          <p>
            BIXBY reserves the right to change this Privacy Policy at any time by posting revisions on this Web page.
            Such changes will be effective upon posting. Last Updated: September 26, 2019.
          </p>
        </section>
      </div>
    </React.Fragment>
  );
};

export default PrivacyPolicy;
